<div class="p-2 space-y-2">
  <!-- tu-componente.component.html -->
<form [formGroup]="form">
  <!-- Grid de 3 columnas para los campos de retenciones -->
  <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
    
    <!-- ReteFuente -->
    <div class="flex flex-col">
      <label for="ReteFuente" class="text-sm font-medium mb-1">
        Rete Fuente (%)
      </label>
      <p-inputNumber
        formControlName="ReteFuente"
        id="ReteFuente"
        inputId="ReteFuente"
        mode="decimal"
        [prefix]="'%'"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- ReteFuenteValor -->
    <div class="flex flex-col">
      <label for="ReteFuenteValor" class="text-sm font-medium mb-1">
        Rete Fuente Valor
      </label>
      <p-inputNumber
        formControlName="ReteFuenteValor"
        id="ReteFuenteValor"
        inputId="ReteFuenteValor"
        mode="currency"
        currency="USD"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- Espacio para mantener la cuadrícula -->

    <!-- ReteIVA -->
    <div class="flex flex-col">
      <label for="ReteIVA" class="text-sm font-medium mb-1">
        Rete IVA (%)
      </label>
      <p-inputNumber
        formControlName="ReteIVA"
        id="ReteIVA"
        inputId="ReteIVA"
        mode="decimal"
        [prefix]="'%'"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- ReteIVAValor -->
    <div class="flex flex-col">
      <label for="ReteIVAValor" class="text-sm font-medium mb-1">
        Rete IVA Valor
      </label>
      <p-inputNumber
        formControlName="ReteIVAValor"
        id="ReteIVAValor"
        inputId="ReteIVAValor"
        mode="currency"
        currency="USD"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- Espacio para mantener la cuadrícula -->

    <!-- ReteICA -->
    <div class="flex flex-col">
      <label for="ReteICA" class="text-sm font-medium mb-1">
        Rete ICA (%)
      </label>
      <p-inputNumber
        formControlName="ReteICA"
        id="ReteICA"
        inputId="ReteICA"
        mode="decimal"
        [prefix]="'%'"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- ReteICAValor -->
    <div class="flex flex-col">
      <label for="ReteICAValor" class="text-sm font-medium mb-1">
        Rete ICA Valor
      </label>
      <p-inputNumber
        formControlName="ReteICAValor"
        id="ReteICAValor"
        inputId="ReteICAValor"
        mode="currency"
        currency="USD"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- Espacio para mantener la cuadrícula -->

    <!-- Procultura -->
    <div class="flex flex-col">
      <label for="Procultura" class="text-sm font-medium mb-1">
        Procultura (%)
      </label>
      <p-inputNumber
        formControlName="Procultura"
        id="Procultura"
        inputId="Procultura"
        mode="decimal"
        [prefix]="'%'"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- ProculturaValor -->
    <div class="flex flex-col">
      <label for="ProculturaValor" class="text-sm font-medium mb-1">
        Procultura Valor
      </label>
      <p-inputNumber
        formControlName="ProculturaValor"
        id="ProculturaValor"
        inputId="ProculturaValor"
        mode="currency"
        currency="USD"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>

    <!-- cmpoValoraPagar -->
    <div class="flex flex-col">
      <label for="cmpoValoraPagar" class="text-sm font-medium mb-1">
        Valor a Pagar
      </label>
      <p-inputNumber
        formControlName="cmpoValoraPagar"
        id="cmpoValoraPagar"
        inputId="cmpoValoraPagar"
        mode="currency"
        currency="USD"
        locale="en-US"
        class="w-full"
      ></p-inputNumber>
    </div>
  </div>

  <!-- No Aplican Retenciones (Toggle) -->
  <div class="pt-4">
    <div class="flex items-center space-x-3">
      <p-toggleswitch
        formControlName="NoAplicanRetenciones"
        [trueValue]="true"
        [falseValue]="false"
        inputId="NoAplicanRetenciones"
      ></p-toggleswitch>
      <label for="NoAplicanRetenciones" class="text-sm font-medium">
        No aplican retenciones
      </label>
    </div>
  </div>

  <!-- Observación (TextArea) -->
  <div class="pt-4">
    <label for="Observacion" class="text-sm font-medium mb-1 block">
      Observación
    </label>
    <textarea
      formControlName="Observacion"
      id="Observacion"
      rows="5"
      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      placeholder="Ingrese una observación..."
    ></textarea>
  </div> 
</form>
</div>

<!-- Botones -->
<div class="flex justify-end gap-3 pt-4">
  <p-button
    type="button"
    label="Cancelar"
    icon="icon-cross"
    severity="danger"
    outlined
    (click)="cerrarModal()"
  >
  </p-button>

  @if (!isModoEdit()) {
    <p-button
      type="button"
      label="Crear"
      icon="icon-plus"
      severity="success"
      [disabled]="form.invalid"
      outlined
      (click)="crear()"
    >
    </p-button>
  }

  @if (isModoEdit()) {
    <p-button
      type="button"
      label="Actualizar"
      icon="icon-checkmark"
      severity="success"
      [disabled]="form.invalid"
      outlined
      (click)="editar()"
    >
    </p-button>
    <p-button
      type="button"
      label="Eliminar"
      icon="icon-minus"
      severity="warn"
      outlined
      (click)="eliminar()"
    >
    </p-button>
  }
  
</div>
